import axios from 'axios';

import { baseUrl } from '#api/baseUrl';

export const postPathsAndCourses = async value => {
  try {
    const { data } = await axios.post(`${baseUrl}/api/web/section-paths-courses/`, value);
    return data;
  } catch (error) {}
};

export const postPathsDetails = async value => {
  try {
    const { data } = await axios.post(`${baseUrl}/api/web/detail/learning-path/`, value);
    return data;
  } catch (error) {}
};

export const postCoursesDetails = async value => {
  try {
    const { data } = await axios.post(`${baseUrl}/api/web/detail/course/`, value);
    return data;
  } catch (error) {}
};

export const postAllianceDetail = async value => {
  try {
    const { data } = await axios.post(
      `${baseUrl}/api/alliances/alliance-details/`,
      value
    );
    return data;
  } catch (error) {}
};
